import React, { useState, useRef, useEffect } from "react";
import Layout from "../Layout/Layout";
import "./Rough.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { selectedLang, testResult } from "../../utils/recoil";
import Cookies from "js-cookie";
import { Toast } from "primereact/toast";
import config from "../../config";
import { LoadingPage } from "../LoadingPage/LoadingPage";
import { countries } from "../../utils/data";
import { MdLanguage } from "react-icons/md";
import { Dropdown } from "primereact/dropdown";

const cities = [
  { name: "English", code: "en" },
  { name: "Hindi", code: "hi" },
  { name: "Malayalam", code: "mal" },
  { name: "Arabic", code: "ar" },
  { name: "Tamil", code: "ta" },
];

const staticQuestions = [
  { id: 1, en: "I am the life of the party.", hi: "", ar: "", mal: "", ta: "" },
  {
    id: 2,
    en: "I feel little concern for others.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  { id: 3, en: "I am always prepared.", hi: "", ar: "", mal: "", ta: "" },
  { id: 4, en: "I get stressed out easily.", hi: "", ar: "", mal: "", ta: "" },
  { id: 5, en: "I have a rich vocabulary.", hi: "", ar: "", mal: "", ta: "" },
  { id: 6, en: "I don't talk a lot.", hi: "", ar: "", mal: "", ta: "" },
  { id: 7, en: "I am interested in people.", hi: "", ar: "", mal: "", ta: "" },
  {
    id: 8,
    en: "I leave my belongings around.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  {
    id: 9,
    en: "I am relaxed most of the time.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  {
    id: 10,
    en: "I have difficulty understanding abstract ideas.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  {
    id: 11,
    en: "I feel comfortable around people.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  { id: 12, en: "I insult people.", hi: "", ar: "", mal: "", ta: "" },
  {
    id: 13,
    en: "I pay attention to details.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  { id: 14, en: "I worry about things.", hi: "", ar: "", mal: "", ta: "" },
  {
    id: 15,
    en: "I have a vivid imagination.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  { id: 16, en: "I keep in the background.", hi: "", ar: "", mal: "", ta: "" },
  {
    id: 17,
    en: "I sympathize with others' feelings.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  { id: 18, en: "I make a mess of things.", hi: "", ar: "", mal: "", ta: "" },
  { id: 19, en: "I seldom feel blue.", hi: "", ar: "", mal: "", ta: "" },
  {
    id: 20,
    en: "I am not interested in abstract ideas.",
    hi: "",
    ar: "",
    mal: "",
    ta: "",
  },
  { id: 21, en: "Select Gender.", hi: "", ar: "", mal: "", ta: "" },
];

const Rough = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [lang, setLang] = useRecoilState(selectedLang);
  const [questions, setQuestions] = useState([]);
  const setTestResult = useSetRecoilState(testResult);
  const tokenCookie = Cookies.get("token", { domain: config.cookieDomain });
  const isPaidCookie = Cookies.get("role", { domain: config.cookieDomain });
  const isTestTaken = Cookies.get("isTestAttended", {
    domain: config.cookieDomain,
  });
  const usernameCookie = Cookies.get("username", {
    domain: config.cookieDomain,
  });
  const navigate = useNavigate();
  const toast = useRef(null);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [selectedOptions, setSelectedOptions] = useState(
    Array(questions.length).fill(null),
  );
  const [clickedButtons, setClickedButtons] = useState(
    Array(questions.length).fill(null),
  );
  const [demographics, setDemographics] = useState({
    gender: "",
    age: "",
    country: "",
  });
  const [opacity, setOpacity] = useState(0);
  const questionRefs = useRef(Array(questions.length).fill(null));

  const changeLanguage = (e) => {
    console.log(e.value);
    localStorage.setItem("lang", e.value.code);
    setLang(e.value);
    setSearchParams({ lang: e.value.code });
  };

  useEffect(() => {
    if (tokenCookie) {
      // if (isPaidCookie && isPaidCookie === "ROLE_UNPAID_USER")
      //   navigate({ pathname: "/home", search: location.search });
      if (isTestTaken && isTestTaken === "TRUE")
        navigate({ pathname: "/my_profile", search: location.search });
      // } else {
      //   window.location.href = config.domain + "/login";
    }

    let user = JSON.parse(localStorage.getItem("user"));
    let items;
    let clickedBtns;
    if (user && usernameCookie in user) {
      items = user[usernameCookie]?.item;
      clickedBtns = user[usernameCookie]?.clickedButtons;
    }

    if (items && clickedBtns) {
      setSelectedOptions(items);
      setOpacity(items?.length);
      setClickedButtons(clickedBtns);
      // questionRefs.current[items?.length].scrollIntoView({
      //   behavior: "smooth",
      // });
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (tokenCookie) {
      let questionsFromLocal = JSON.parse(localStorage.getItem("questions"));
      if (questionsFromLocal?.length) {
        setQuestions(questionsFromLocal);
        setLoading(false);
      } else {
        // setQuestions(staticQuestions);
        // setLoading(false);
        fetch(config.domain + "/questions", {
          credentials: "include",
        })
          .then((res) => res.json())
          .then((res1) => {
            let data = [...res1.data].sort(() => Math.random() - 0.5);
            console.log(data);
            // let data = [...res1.data].slice(0, 5);
            data.push({ id: res1.data?.length + 1, en: "Select Gender." });
            setQuestions(data);
            localStorage.setItem("questions", JSON.stringify(data));
            setLoading(false);
          })
          .catch((err) => {
            console.log("error: " + err);
            setQuestions(staticQuestions);
            setLoading(false);
          });
      }
    }
  }, []);

  const [result, setResult] = useState([]);

  const showMissingFieldWarning = (field) => {
    toast.current.show({
      severity: "warn",
      summary: "Warning",
      detail: `${field} not selected`,
      life: 3000,
    });
  };

  const handleSubmit = () => {
    const answeredQuestionsCount = selectedOptions.filter(
      (option) => option,
    ).length;
    if (!demographics.gender) {
      showMissingFieldWarning("gender");
      return;
    }

    if (!demographics.age) {
      showMissingFieldWarning("age");
      return;
    }

    if (!demographics.country) {
      showMissingFieldWarning("country");
      return;
    }

    if (answeredQuestionsCount === questions.length - 1) {
      setLoading(true);
      // navigate({ pathname: "/result-page", search: location.search });
      const rawResponse = fetch(config.domain + "/submit-response", {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: selectedOptions,
          demographics,
        }),
      })
        .then((res) => res.json())
        .then((res1) => {
          // console.log("submit response: ", res1.data)
          setLoading(false);
          navigate({ pathname: "/result-page", search: location.search });
        })
        .catch((err) => {
          console.log("error: " + err);
          toast.current.show({
            severity: "error",
            summary: "Submission Failed",
            detail: "Failed to submit the test",
            life: 3000,
          });
          navigate({ pathname: "/result-page", search: location.search });
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "please attend all questions",
        life: 3000,
      });
      navigate({ pathname: "/result-page", search: location.search });
    }
  };

  // State to keep track of selected option for each question

  // State to keep track of clicked status for each button

  // Ref for questions

  // Function to handle button click
  const handleButtonClick = (questionIndex, optionIndex, qid) => {
    // Update the selected option for the question
    const newSelectedOptions = [...selectedOptions];
    newSelectedOptions[questionIndex] = { id: qid, choice: optionIndex };
    setSelectedOptions(newSelectedOptions);
    setOpacity(questionIndex + 1);

    // Update the clicked status for the button
    const newClickedButtons = [...clickedButtons];
    newClickedButtons[questionIndex] = optionIndex;
    setClickedButtons(newClickedButtons);
    const userDetails = {
      [usernameCookie]: {
        item: newSelectedOptions,
        clickedButtons: newClickedButtons,
      },
    };
    localStorage.setItem("user", JSON.stringify(userDetails));
    // Scroll to the next question if it exists
    if (questionIndex < questions.length - 1) {
      questionRefs.current[questionIndex + 1].scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  // Function to handle gender selection
  const handleGenderSelection = (event) => {
    // Update selected options for all questions
    // const updatedSelectedOptions = selectedOptions;
    // updatedSelectedOptions[questions.length - 1] = {
    //   gender: event.target.value,
    // };
    // // setSelectedOptions(updatedSelectedOptions);
    // // Update opacity to show all questions
    // setOpacity(questions.length);
    // // Scroll to the last question
    // questionRefs.current[questions.length - 1].scrollIntoView({
    //   behavior: "smooth",
    // });
  };

  const handleDemographicChange = (field, value) => {
    setDemographics((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Calculate completion percentage
  const completedQuestions = selectedOptions
    .filter((option) => option)
    .filter(
      (option, index) =>
        index !== questions.length - 1 && option !== null && option !== "",
    ).length;
  const totalQuestions = questions.length - 1; // Excluding gender question from total
  const completionPercentage = (completedQuestions / totalQuestions) * 100;

  return (
    <Layout>
      {loading ? (
        <LoadingPage />
      ) : (
        <>
          <Toast ref={toast} />
          {/* {tokenCookie && ( */}
          <div className="personality-container ">
            <div className="items-center px-2 bg-white rounded-md md-max:flex hidden">
              <MdLanguage size={40} color="#3976F9" className="font-normal" />
              <Dropdown
                // value={searchParams.get("lang") ?? lang}
                value={cities?.find(
                  (city) => city.code === searchParams.get("lang") ?? lang,
                )}
                // onChange={(e) =>
                //   startTransition(() => {
                //     setLang(e.value);
                //   })
                // }
                onChange={(e) => changeLanguage(e)}
                options={cities}
                optionLabel="name"
                placeholder="Select Language"
                className="px-6 py-3 text-[16px ] "
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "black",
                  width: "150px",
                }}
              />
            </div>
            <div className="hidden">
              <div className="personality-heading">
                <h1>
                  Free Personality Test by{" "}
                  <span style={{ color: "#1C75BC" }}>Uslot</span>
                </h1>
              </div>
            </div>
            <div className="quistion-main-box ">
              <div
                className="loader"
                style={{ width: `${completionPercentage}%` }}
              ></div>
              <div className="complete-box">
                <h1>{completionPercentage.toFixed(0)}% completed</h1>
              </div>
              <div className="quistons-main scrollbar-hide">
                {/* Mapping questions */}
                {questions.map((question, questionIndex) => (
                  <div
                    className="q-t "
                    key={questionIndex}
                    ref={(el) => (questionRefs.current[questionIndex] = el)}
                  >
                    <div
                      className={`main-2  ${
                        questionIndex !== opacity && "opacity"
                      }`}
                    >
                      <div className="q-t-heading">
                        <h1 className="fade-in">{question[lang.code]}</h1>
                      </div>
                    </div>
                    <div className="answer-button">
                      {/* Add onClick event handler to all buttons */}
                      {questionIndex !== questions.length - 1 ? (
                        <>
                          <h2
                            className={`disagree-button ${
                              questionIndex !== opacity && "op"
                            }`}
                          >
                            Disagree
                          </h2>
                          <div
                            className={`bigroundgreen3-button  ${
                              questionIndex !== opacity && "opa"
                            } ${
                              clickedButtons[questionIndex] === 1
                                ? "clicke"
                                : ""
                            } size-6`}
                            onClick={() =>
                              handleButtonClick(questionIndex, 1, question.id)
                            }
                          ></div>
                          <div
                            className={`bigroundgreen2-button  ${
                              questionIndex !== opacity && "opa"
                            } ${
                              clickedButtons[questionIndex] === 2
                                ? "clicke"
                                : ""
                            } size-5`}
                            onClick={() =>
                              handleButtonClick(questionIndex, 2, question.id)
                            }
                          ></div>
                          <div
                            className={`biground4-button  ${
                              questionIndex !== opacity && "opa"
                            } ${
                              clickedButtons[questionIndex] === 3
                                ? "clicked"
                                : ""
                            } size-4`}
                            onClick={() =>
                              handleButtonClick(questionIndex, 3, question.id)
                            }
                          ></div>
                          <div
                            className={`biground3-button  ${
                              questionIndex !== opacity && "opa"
                            } ${
                              clickedButtons[questionIndex] === 4
                                ? "clicked"
                                : ""
                            } size-3`}
                            onClick={() =>
                              handleButtonClick(questionIndex, 4, question.id)
                            }
                          ></div>
                          <div
                            className={`biground2-button ${
                              questionIndex !== opacity && "opa"
                            } ${
                              clickedButtons[questionIndex] === 5
                                ? "clicked"
                                : ""
                            } size-2`}
                            onClick={() =>
                              handleButtonClick(questionIndex, 5, question.id)
                            }
                          ></div>
                          <h2
                            className={`agree-button ${
                              questionIndex !== opacity && "op"
                            }`}
                          >
                            Agree{" "}
                          </h2>
                        </>
                      ) : (
                        <div className="flex sm-max:flex-col gap-5">
                          <div className="select-dropdown">
                            <select
                              className="!text-[#1C75BC]"
                              value={demographics.gender}
                              onChange={(e) =>
                                handleDemographicChange(
                                  "gender",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">Select Gender</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                              <option value="other">Other</option>
                            </select>
                            <div className="arrow-icon">&#9660;</div>
                          </div>

                          <div className="select-dropdown">
                            <select
                              className="!text-[#1C75BC]"
                              value={demographics.age}
                              onChange={(e) =>
                                handleDemographicChange("age", e.target.value)
                              }
                            >
                              <option value="">Select Age</option>
                              {[...Array(100)].map((_, i) => (
                                <option key={i + 1} value={i + 1}>
                                  {i + 1}
                                </option>
                              ))}
                            </select>
                            <div className="arrow-icon">&#9660;</div>
                          </div>

                          <div className="select-dropdown">
                            <select
                              className="!text-[#1C75BC]"
                              value={demographics.country}
                              onChange={(e) =>
                                handleDemographicChange(
                                  "country",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">Select Country</option>
                              {countries.map((country, index) => (
                                <option key={index} value={country.name}>
                                  {country.name}
                                </option>
                              ))}
                            </select>
                            <div className="arrow-icon">&#9660;</div>
                          </div>
                        </div>
                      )}
                    </div>
                    {questionIndex !== questions.length - 1 && (
                      <div className="mobile-view-buttons">
                        <div className="agree-disagree-buttons">
                          <h2>Disagree</h2>
                          <h2>Agree</h2>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                {/* End of mapped questions */}
                <div className="complete-button">
                  <button onClick={handleSubmit}>Finish</button>
                </div>
              </div>
            </div>
          </div>
          {/* )} */}
        </>
      )}
    </Layout>
  );
};

export default Rough;
